import React, { useState, useEffect } from 'react';
import { Button, Form, Card, Modal, Badge } from 'react-bootstrap';
import { apiFetch, API_URL } from '../../../utils/api.js';
import ImageCropper from '../../../components/cropper/ImageCropper';

export function AdminSlides() {
  const [slides, setSlides] = useState([]);
  const [show, setShow] = useState(false);
  
  const [title, setTitle] = useState('');
  const [text, setText] = useState('');
  const [image, setImage] = useState(null);

  // Стейты кроппера
  const [imageSrc, setImageSrc] = useState(null);
  const [cropSuccess, setCropSuccess] = useState(false);

  const fetchSlides = async () => {
    const res = await apiFetch('/api/slides');
    const data = await res.json();
    setSlides(data);
  };

  useEffect(() => { fetchSlides(); },[]);

  const handleClose = () => {
    setShow(false);
    setTitle(''); setText(''); setImage(null); setCropSuccess(false);
  };

  const onFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setImageSrc(reader.result);
        setCropSuccess(false);
      };
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!image) return alert('Выберите и обработайте изображение!');
    
    const data = new FormData();
    data.append('title', title);
    data.append('text', text);
    data.append('image', image);

    const res = await apiFetch('/api/slides', { method: 'POST', body: data });
    if (res.ok) {
      handleClose();
      fetchSlides();
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Удалить этот баннер?")) {
      await apiFetch(`/api/slides/${id}`, { method: 'DELETE' });
      fetchSlides();
    }
  };

  // Окно кроппера
  if (imageSrc) {
    return (
      <Modal show={true} onHide={() => setImageSrc(null)} centered size="lg" backdrop="static">
        <Modal.Header closeButton className="border-0"><Modal.Title className="fw-bold">Кадрирование баннера (16:9)</Modal.Title></Modal.Header>
        <Modal.Body className="px-4 pb-4">
          <ImageCropper 
            imageSrc={imageSrc} 
            aspect={16/9} // Широкоформатная пропорция для главной страницы
            onCancel={() => setImageSrc(null)}
            onCropDone={(file) => {
              setImage(file);
              setImageSrc(null);
              setCropSuccess(true);
            }}
          />
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <div>
      <div className="mb-4">
        <h2 className="fw-bold">Баннеры на главной</h2> 
        <p className="text-muted">Большие фоновые изображения в самом верху сайта.</p>
      </div>
      <div className="mb-4">
        <Button className="btn-corp" onClick={() => setShow(true)}>Добавить баннер</Button>
      </div>

      <div className="d-flex flex-wrap gap-4">
        {slides.map(slide => (
          <Card key={slide.id} className="corp-card" style={{ width: '28rem' }}>
            <Card.Img variant="top" src={`${API_URL}/${slide.image}`} style={{ height: '220px', objectFit: 'cover' }} />
            <Card.Body className="p-4">
              <Card.Title className="fw-bold">{slide.title}</Card.Title>
              <Card.Text className="text-muted small">{slide.text}</Card.Text>
              <Button variant="outline-danger" size="sm" onClick={() => handleDelete(slide.id)}>Удалить</Button>
            </Card.Body>
          </Card>
        ))}
      </div>

      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton className="border-0"><Modal.Title className="fw-bold">Новый баннер</Modal.Title></Modal.Header>
        <Modal.Body className="px-4">
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-bold text-muted text-uppercase">Заголовок (крупный текст)</Form.Label>
              <Form.Control className="bg-light border-0 py-2" type="text" value={title} onChange={(e) => setTitle(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-bold text-muted text-uppercase">Описание (мелкий текст)</Form.Label>
              <Form.Control className="bg-light border-0 py-2" as="textarea" rows={3} value={text} onChange={(e) => setText(e.target.value)} />
            </Form.Group>
            <Form.Group>
              <Form.Label className="small fw-bold text-muted text-uppercase d-block">Фоновое изображение</Form.Label>
              <div className="d-flex align-items-center gap-3">
                <Form.Control type="file" accept="image/*" onChange={onFileChange} className="bg-light border-0" />
                {cropSuccess && <Badge bg="success" className="px-3 py-2">Фото обрезано <i className="bi bi-check-circle ms-1"></i></Badge>}
              </div>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="light" onClick={handleClose}>Отмена</Button>
          <Button className="btn-corp" onClick={handleSubmit}>Сохранить</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
